import React from 'react';
import { Task } from '../../../../types/task';
import { TaskItemV2 } from './TaskItemV2';
import { DraggableTaskItemV2 } from './DraggableTaskItemV2';

interface TaskItemV2ListProps {
  tasks: Task[];
  onToggle: (taskId: string, completed: boolean) => void;
  onClick: (taskId: string) => void;
  onTaskUpdate?: (taskId: string, updates: { projectId?: string; vital?: boolean; urgent?: boolean }) => void;
  className?: string;
  compact?: boolean;
  viewMode?: 'list' | 'timeline';
  showBackground?: boolean; // 是否显示背景色（默认true）
  // 拖拽相关
  enableDrag?: boolean;
  dropZoneType?: 'project' | 'importance' | 'both';
}

/**
 * TaskItemV2List 容器组件
 * 样式上完全透明，包装多个TaskItemV2使其支持拖拽
 * 支持项目和重要性属性的拖拽修改
 */
export const TaskItemV2List: React.FC<TaskItemV2ListProps> = ({
  tasks,
  onToggle,
  onClick,
  onTaskUpdate,
  className = '',
  compact = false,
  viewMode = 'list',
  showBackground = true,
  enableDrag = true,
  dropZoneType = 'both'
}) => {
  return (
    <div className={className}>
      {tasks.map((task) => (
        enableDrag ? (
          <DraggableTaskItemV2
            key={task.id}
            task={task}
            onToggle={onToggle}
            onClick={onClick}
            onTaskUpdate={onTaskUpdate}
            compact={compact}
            viewMode={viewMode}
            showBackground={showBackground}
            dropZoneType={dropZoneType}
          />
        ) : (
          <TaskItemV2
            key={task.id}
            task={task}
            onToggle={onToggle}
            onClick={onClick}
            compact={compact}
            viewMode={viewMode}
            showBackground={showBackground}
          />
        )
      ))}
    </div>
  );
};
